import { createFileRoute } from '@tanstack/react-router';

// テストセット詳細 > テスト概要タブの Route 定義。
// component は index.lazy.tsx 側で lazy ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/test-sets/$id/_layout/')({});
